import { useQuery} from '@tanstack/react-query';
import axiosClient from '../api/interceptor-v2';

const fetchIncidentTrack = async () => {

  const response = await axiosClient.get(`/incident_tracking`)
  return response.data.result;

};

export function useIncidentTrack() {
    return useQuery({
        queryKey: ['getIncidentTrack'],
        queryFn: fetchIncidentTrack,
        cacheTime: 24 * 60 * 60 * 1000, 
        refetchInterval: 60 * 60 * 1000
    });
}
